module.exports = __webpack_public_path__ + "img/6_22.d7ac5f19.png";